import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'requestType'
})
export class RequestTypePipe implements PipeTransform {
  private readonly valueMap = {
    PROVIDERRESIGNATION: 'Resignation',
    PROVIDERMAINTENANCE: 'Maintenance',
    PROVIDERNEW: 'New Provider',
    PRACTICENEW: 'Setup a New Practice',
    PRACTICERESIGNATION: 'Resign Participation',
    PRACTICEMAINTENANCE: 'Maintenance'
  };

  transform(value: any, ...args: any[]): any {
    return this.valueMap[value] ? this.valueMap[value] : value;
  }
}
